import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import noop from 'lodash/noop';
import Flag, { FlagGroup } from '@atlaskit/flag';
import { buttonActionTypes } from '../../common/types/button';
import HtmlContent from '../../controllers/utils/html-content';
import allowedIcons from './utils/allowed-icons';
// eslint-disable-next-line @repo/internal/react/no-class-components
export default class EngagementFlag extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onDismiss", () => {
      this.props.fireClickEvent('dismiss');
    });
    _defineProperty(this, "onPrimaryClick", () => {
      const {
        fireClickEvent,
        primaryAction
      } = this.props;
      fireClickEvent('primary');
      this.onClickActionHandler(primaryAction);
    });
    _defineProperty(this, "onSecondaryClick", () => {
      const {
        fireClickEvent,
        secondaryAction
      } = this.props;
      fireClickEvent('secondary');
      this.onClickActionHandler(secondaryAction);
    });
  }
  onClickActionHandler(action) {
    if (action && action.type === buttonActionTypes.LINK && action.data) {
      window.open(action.data.url, action.data.target);
    }
  }
  render() {
    const {
      title,
      body,
      primaryText,
      secondaryText,
      icon
    } = this.props;
    const actions = [{
      content: primaryText,
      onClick: this.onPrimaryClick
    }];
    if (secondaryText) {
      actions.push({
        content: secondaryText,
        onClick: this.onSecondaryClick
      });
    }
    const selectedIcon = allowedIcons[icon];
    const FlagIconComponent = selectedIcon && selectedIcon.component;
    const FlagIcon = FlagIconComponent ? /*#__PURE__*/React.createElement(FlagIconComponent, {
      label: selectedIcon.label,
      primaryColor: selectedIcon.color
    }) : null;
    return /*#__PURE__*/React.createElement(FlagGroup, {
      onDismissed: this.onDismiss
    }, /*#__PURE__*/React.createElement(Flag, {
      id: "engagement-flag",
      appearance: "normal",
      icon: FlagIcon,
      title: title,
      description: /*#__PURE__*/React.createElement(HtmlContent, {
        html: body
      }),
      actions: actions
    }));
  }
}
_defineProperty(EngagementFlag, "defaultProps", {
  fireClickEvent: noop,
  primaryText: null,
  primaryAction: null,
  secondaryText: null,
  secondaryAction: null,
  icon: 'smallInfo'
});